import { Injectable } from '@angular/core';

import { LinkTarget } from '../constants/link-target.enum';

export const enum LaunchAction {
    AllowFilesSystemAccess = 'AllowFilesSystemAccess',
    AnnouncementAction = 'AnnouncementAction',
    CopyNotebook = 'CopyNotebook',
    CreateFileWithTemplate = 'CreateFileWithTemplate',
    CreateFromDocument = 'CreateFromDocument',
    CreateNewEvent = 'CreateNewEvent',
    CreateNewFallback = 'CreateNewFallback',
    Download = 'Download',
    EmailFromPeopleCard = 'EmailFromPeopleCard',
    EmailOrganizer = 'EmailOrganizer',
    FREAction = 'FREAction',
    GoToBlankDoc = 'GoToBlankDoc',
    HandleNumberFromPeopleCard = 'HandleNumberFromPeopleCard',
    Install = 'Install',
    InstallAdditional = 'InstallAdditional',
    LaunchProtocol = 'LaunchProtocol',
    ODSPRedirect = 'ODSP_Redirect',
    OneDriveRedirect = 'OneDriveRedirect',
    OpenAppTile = 'OpenAppTile',
    OpenAttachment = 'OpenAttachment',
    OpenAutosuggestApp = 'OpenAutosuggestApp',
    OpenAutoSuggestBing = 'OpenAutosuggestBing',
    OpenAutosuggestFile = 'OpenAutosuggestFile',
    OpenAutosuggestGoTo = 'OpenAutosuggestGoTo',
    OpenAutosuggestSeeMore = 'OpenAutosuggestSeeMore',
    OpenAutoSuggestSetting = 'OpenAutoSuggestSetting',
    OpenAutosuggestTemplate = 'OpenAutosuggestTemplate',
    OpenChatFromPeopleCard = 'OpenChatFromPeopleCard',
    OpenDocFromPeopleCard = 'OpenDocFromPeopleCard',
    OpenEvent = 'OpenEvent',
    OpenFile = 'OpenFile',
    OpenFileLocation = 'OpenFileLocation',
    OpenGalleryItem = 'OpenGalleryItem',
    OpenInApp = 'OpenInApp',
    OpenJumpListItem = 'OpenJumpListItem',
    OpenLearnMoreLink = 'OpenLearnMoreLink',
    OpenMoreMSCreateTemplates = 'OpenMoreMSCreateTemplates',
    OpenMruItem = 'OpenMruItem',
    OpenOneDriveUploadAction = 'OpenOneDriveUploadAction',
    OpenSkypeMeeting = 'OpenSkypeMeeting',
    OpenTeamsMeeting = 'OpenTeamsMeeting',
    OpenTemplate = 'OpenTemplate',
    OpenToDoLink = 'OpenToDoLink',
    RecommendedDeepLink = 'RecommendedDeepLink',
    SharePointRedirect = 'SharePointRedirect',
    Upload = 'Upload',
    Upsell = 'Upsell'
}

@Injectable()
export abstract class UrlLauncherService {
    /**
     * Attempts to launch a given url with provided target and width/height
     *
     * @param url url to launch
     * @param action string that identifies the action being taken for instrumentation purposes
     * @param linkTarget target to use when opening window
     * @param width: pixel width of new window
     * @param height: pixel height of new window
     * @returns Promise indicating whether launch succeeded
     */
    public abstract openUrl(url: string, action: LaunchAction, linkTarget?: LinkTarget, width?: number, height?: number): Promise<void>;

    /**
     * Determines whether the given protocol is supported
     *
     * @param protocol Protocol for which to determine support
     * @returns Whether given protocol is supported
     */
    public abstract supportsProtocol(protocol: string): Promise<boolean>;
}
